import { UserLocationShare } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateUserLocationShareArgs,
    UpdateUserLocationShareArgs,
} from "@nova/serializer/src/client/validators/flights/userLocationShare"
import { deleteEntitySocket, updateEntitySocket } from "features/entity-caching/project/slice"

const {
    update: updateUserLocationShare,
    delete: deleteUserLocationShare,
    updateAction,
    deleteAction,
} = generateGenericCases<
    UserLocationShare, // entity type
    CreateUserLocationShareArgs, // create args to send to server
    [], // create args required by action — unused, never client-created
    UpdateUserLocationShareArgs // update args
>("UserLocationShare")

export const addUserLocationSharesToBuilder = (builder: Builder) =>
    builder
        .addCase(updateAction, (store, { payload: { id, updates } }, socket) => {
            updateUserLocationShare(socket, id, updates)
            store.dispatch(
                updateEntitySocket({ id, updates, path: ["userLocationShares", { id }] })
            )
        })
        .addCase(deleteAction, (store, { payload: { id } }, socket) => {
            deleteUserLocationShare(socket, id)
            store.dispatch(deleteEntitySocket({ path: ["userLocationShares", { id }] }))
        })

export { updateAction as updateUserLocationShare, deleteAction as deleteUserLocationShare }
